<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Winter Archivist</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#part-one">Part One</a></li>
<li id="toc-li-4"><span href="#/text/ch004#part-two" title="Link target outside of Sample">Part Two</span><ol class="toc"><li id="toc-li-5"><span href="#/text/Section0002#leipzig-1985" title="Link target outside of Sample">Leipzig 1985</span></li>
<li id="toc-li-6"><span href="#/text/Section0003#willi" title="Link target outside of Sample">Willi</span></li>
<li id="toc-li-7"><span href="#/text/Section0004#versur-1980" title="Link target outside of Sample">Versur 1980</span></li>
<li id="toc-li-8"><span href="#/text/Section0005#herr-winter" title="Link target outside of Sample">Herr Winter</span></li>
<li id="toc-li-9"><span href="#/text/Section0006#bloomsbury-1986" title="Link target outside of Sample">Bloomsbury 1986</span></li>
<li id="toc-li-10"><span href="#/text/Section0007#friederike" title="Link target outside of Sample">Friederike</span></li>
<li id="toc-li-11"><span href="#/text/Section0008#venice-1995" title="Link target outside of Sample">Venice 1995</span></li>
<li id="toc-li-12"><span href="#/text/Section0009#peter" title="Link target outside of Sample">Peter</span></li>
<li id="toc-li-13"><span href="#/text/Section0010#lyon-2011" title="Link target outside of Sample">Lyon 2011</span></li>
</ol></li>
<li id="toc-li-14"><span href="#/text/ch005#part-three" title="Link target outside of Sample">Part Three</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?42d5b443